import {
  FACEBOOK_PLATFORM,
  FACEBOOK_PROVIDER_PLATFORM,
  GOOGLE_PLATFORM,
  GOOGLE_PROVIDER_PLATFORM,
  DV_360_PLATFORM,
  DV_360_PROVIDER_PLATFORM,
  TIKTOK_PLATFORM,
  TIKTOK_PROVIDER_PLATFORM,
  GOOGLE_AD_MANAGER_PLATFORM
} from './selectLists/platformList'

// endpoint has different platform parameter to ROUTES
export const ENDPOINT_PLATFORM: { [key: string]: any } = {
  [FACEBOOK_PLATFORM]: FACEBOOK_PROVIDER_PLATFORM,
  [GOOGLE_PLATFORM]: GOOGLE_PROVIDER_PLATFORM,
  [DV_360_PLATFORM]: DV_360_PROVIDER_PLATFORM,
  [TIKTOK_PLATFORM]: TIKTOK_PROVIDER_PLATFORM,
  [GOOGLE_AD_MANAGER_PLATFORM]: 'google_ad_manager'
}

export const WEB_SOCKET_ENDPOINTS = {
  streamAiSuggestions: '/api/ws/stream_suggestions/' // this is a websocket endpoint and it is not in Swagger library
}

export const ENDPOINTS = {
  currentUserProfile: '/api/users/me/', // users_me_read
  users: '/api/users/', // users_list
  userSpecific: '/api/users/:id/', // users_read

  // auth
  login: '/api/auth/login/', //auth_login_create
  logout: '/api/auth/logout/', //auth_logout_create
  oauth: '/api/auth/oauth/', //auth_oauth_list
  inviteAccept: '/api/invites/accept/', //invites_accept
  resetPassword: '/api/auth/reset_password/', //auth_reset_password_create
  changePassword: '/api/auth/change-password/', //auth_change-password_create
  sendResetPasswordLink: '/api/auth/send_reset_password_link/', //auth_send_reset_password_link_create
  verify_registration: '/api/auth/verify_registration/', //auth_verify_registration_create'
  resend_register: '/api/resend-register/', // resend-register_create
  token: '/api/token/',

  // social auth
  facebookAuth: '/api/allauth/facebook/login/callback/',
  googleAuth: '/api/allauth/google/login/callback/',
  dv360Auth: '/api/allauth/dv360/login/callback/',
  tikTokAuth: '/api/allauth/tiktok/login/callback/',

  // ads / visuals
  ads: '/api/:platform/visuals/', // ads list
  ad: '/api/:platform/visuals/:id/', // single ad
  copyAd: '/api/:platform/visuals/:id/copy_fb/', // facebook_visuals_copy_fb
  internalAds: '/api/internal_visuals/',

  // facebookPosts
  facebookPosts: '/api/facebook/pages/:facebookPageId/facebook_posts/',

  // campaigns
  campaigns: '/api/:platform/campaigns/', //campaigns_list
  shortInfoCampaigns: '/api/:platform/campaigns/short_info/',
  duplicateCampaign: '/api/:platform/campaigns/:id/copy/',

  // async session
  asyncSession: '/api/:platform/async_sessions/:id/',

  // line items
  lineItems: '/api/:platform/line_items/', //line_items_list
  lineItemsReportsBreakdown: '/api/reports/line_item_breakdown/',
  duplicateLineItem: '/api/:platform/line_items/:id/copy/',
  googleAdManagerLineItemsBulkCreate: '/api/google_ad_manager/line_items/bulk_create/',

  // partnerships
  partnerships: '/api/partnerships/', //partnerships_list

  // rights
  rights: '/api/rights/', //rights_list
  rightsAsync: '/api/async/rights/',
  rightSuggestedChanges: '/api/rights/:id/suggested_changes/',
  rightApplySuggestedChanges: '/api/rights/:id/apply_suggestion/',
  partnerbrainHistory: '/api/partnerbrain_history/',
  rightSocialPosts: '/api/social_posts/',

  // accounts
  accounts: '/api/accounts/', //accounts_list
  adAccounts: '/api/:platform/adaccounts/', //adaccounts_list

  // audiences
  audiences: '/api/:platform/audiences/', //audiences_list,

  // graphs
  graphs: '/api/:platform/campaigns/graphs/', // campaigns graphs
  graphsGeneration: '/api/graphs/generate_data/', // graphs_generate_data

  // combined data
  combinedCampaigns: '/api/combined/campaigns/data/',
  combinedLineItems: '/api/combined/campaigns/line_items/',
  combinedGraphs: '/api/combined/campaigns/graphs/',
  combinedSegmentedData: '/api/combined/campaigns/segmented_data/',
  combinedAds: '/api/combined/campaigns/visuals/',
  combinedExportData: '/api/combined/campaigns/export_data/',

  // choices
  choicesGeolocations: '/api/facebook/choices/geolocations/',
  choicesCountries: '/api/countries/',
  choicesInterests: '/api/facebook/choices/interests/',
  choicesBehaviours: '/api/facebook/choices/behaviours/',
  choicesCategories: '/api/facebook/choices/family_statuses/',
  choicesFacebookLanguages: '/api/facebook/choices/languages/',
  choicesPixels: '/api/facebook/choices/pixels/',
  choicesCTA: '/api/facebook/call_to_actions/',
  choicesActions: '/api/actions/',
  allocationUnits: '/api/allocation_units/',
  facebookClientApps: '/api/facebook/businesses/:bussines-id/client_apps/',
  customConversions: '/api/facebook/custom_conversions/',

  // social accounts
  accessibleSocialPages: '/api/pages/',
  facebookPages: '/api/facebook/pages/',
  facebookPagesRequestAccess: '/api/facebook/pages/request_page_access/',
  facebookPagesLeadGenForms: '/api/facebook/pages/:id/get_lead_gen_forms/',
  facebookDebugTokens: '/api/facebook/debug_tokens/',

  // locations
  locations: '/api/facebook/locations/',
  locationLists: '/api/location_lists/',
  locationAddresses: '/api/location_addresses/',

  // team
  membersList: '/api/members/',
  invitesList: '/api/invites/',
  betaInvites: '/api/beta_invites/',

  // goals
  goals: '/api/facebook/goals/',

  // pixels
  pixels: '/api/facebook/pixels/',
  // files
  signUrl: '/api/file_sign_url/', // sign-url_create
  signUrlBatch: '/api/file_sign_url/batch_create/', // sign-url_create
  privateUploadUrl: '/api/private_upload_url/', // private_upload_url_create
  accessibleUrl: '/api/sign_url/', // sign_url_create
  facebookMediaImage: '/api/facebook/media_files/fb_image_upload/', // media_files_fb_image_upload
  facebookMediaVideo: '/api/facebook/media_files/fb_video_upload/', // media_files_fb_video_upload
  facebookMediaVideoDetail: '/api/facebook/media_files/:id/fb_video_detail/', // media_files_fb_video_detail
  facebookMediaImages: '/api/facebook/media_files/fb_images/',
  facebookMediaVideos: '/api/facebook/media_files/fb_videos/',
  facebookVideoUrls: '/api/facebook/media_files/fb_videos_info/',
  facebookImageUrls: '/api/facebook/media_files/fb_images_info/',
  tikTokVideos: '/api/tiktok/videos/',
  tikTokImages: '/api/tiktok/images/',

  // calendarPlanner
  calendarsList: '/api/calendars/',
  calendarEvents: '/api/events/', // events_list
  calendarEventGroups: '/api/event-groups/',
  updateEventGroupsOrder: '/api/event-groups/order_update/',

  // tools
  changeHistory: '/api/utility_tools/tracking_history/', // utility_tools_tracking_history_list
  selectors: '/api/tools/selectors/', // selectors_list

  // batch_info
  batchInfo: '/api/facebook/batch_info/',

  // google
  googleConstants: '/api/google/google_constants/', // google_constants_list
  googleUsersList: '/api/google/user_lists/', // google_user_lists_list
  campaignAdScheduleCriterions: '/api/google/campaign_criterions/read_ad_schedule/', // campaign_criterions_read_ad_schedule_read
  campaignCriterions: '/api/google/campaign_criterions/', // campaign_criterions_list
  campaignCriterionsBatch: '/api/google/campaign_criterions/batch/', // campaign_criterions_batch
  campaignCriterionsCreateProximity: '/api/google/campaign_criterions/create_proximity/', // campaign_criterions_create_proximity
  campaignCriterionsCreateSchedule: '/api/google/campaign_criterions/create_ad_schedule/', // campaign_criterions_create_schedule
  lineItemCriterions: '/api/google/ad_group_criterions/', // google_ad_group_criterions_list
  lineItemCriterionsBatch: '/api/google/ad_group_criterions/batch/', // google_ad_group_criterions_batch

  // tiktok
  tikTokInterests: '/api/tiktok/interest_categories/',
  tikTokActionCategories: '/api/tiktok/action_categories/',
  tikTokHashtags: '/api/tiktok/recommended_hashtags/',
  tikTokCustomAudiences: '/api/tiktok/custom_audiences/',
  tikTokIdentities: '/api/tiktok/identities/',
  tikTokPixels: '/api/tiktok/pixel_events/',
  tikTokRegions: '/api/tiktok/regions/',
  tikTokVideoThumbnails: '/api/tiktok/video_thumbnails/',
  tiktokLineItemBudgetEdit: '/api/tiktok/line_items/update_budget/',
  tikTokContentExclusionCategories: '/api/tiktok/content_exclusion_categories/',
  tikTokTargetingSearch: '/api/tiktok/targeting_search/',
  tikTokInterestKeywords: '/api/tiktok/interest_keywords/',

  // assets
  assets: '/api/:platform/assets/', // assets_list
  assetsBatch: '/api/:platform/assets/batch/', // google_assets_batch
  assetGroups: '/api/:platform/asset_groups/', // asset_groups_list
  assetGroup: '/api/:platform/asset_groups/:id/', // asset_groups
  assetGroupSignals: '/api/:platform/asset_groups_signals/',
  internalAssetGroups: '/api/google/internal_asset_groups/',

  // banners
  banners: '/api/banners/',

  // margins
  margins: '/api/margin_settings/',
  marginOverride: '/api/margin_setting_overrides/',
  groupedMargins: '/api/margin_settings/grouped/',

  adServerAccess: '/api/onsite_server_access/',
  adServerLineItems: '/api/rights/:rightId/onsite_server/line_items/',

  // targeting options
  targetingOptions: '/api/dv360/targeting_options/',
  targetingOptionsSearch: '/api/dv360/targeting_options/search/',
  targeting: '/api/dv360/targeting/',
  targetingBulkUpdate: '/api/dv360/targeting/bulk_update/',
  dv360Channels: '/api/dv360/channels/',
  negativeKeywordLists: '/api/dv360/negative_keyword_lists/',

  // SROI
  socialReturnOnInvestmentReport: '/api/sroi_reports/:id/fetch-external-report/',
  sroiReportsPayload: '/api/sroi_reports/',
  sroiInputsPreset: '/api/sroi_reports/inputs_preset/',

  // AI suggestions
  aiSuggestionsConversations: '/api/ai_suggestions/conversations/', // ai_suggestions_conversations_list

  // google ad manager
  googleAdManagerPlacements: '/api/google_ad_manager/placements/',
  googleAdManagerAdUnits: '/api/google_ad_manager/ad-units/',
  googleAdManagerLabels: '/api/google_ad_manager/labels/',
  googleAdManagerCustomFields: '/api/google_ad_manager/custom-fields/',
  onsiteRates: '/api/onsite_rates/',
  googleAdManagerConstants: '/api/google_ad_manager/constants/',
  googleAdManagerAudienceSegments: '/api/google_ad_manager/audience-segments/',
  googleAdManagerCustomTargeting: '/api/google_ad_manager/custom-targeting/',
  googleAdManagerCmsMetadata: '/api/google_ad_manager/cms-metadata/',
  googleAdManagerLineItemsForecast: '/api/google_ad_manager/line_items/forecast/',
  gamAdUnitSizes: '/api/google_ad_manager/ad-unit-sizes/'
}
